import React from 'react';
import { useNavigate } from 'react-router-dom';
import CoLearningPromptBackdrop from '../ui/CoLearningPromptBackdrop';
import { coLearningInkBody, coLearningInkTitle } from '../ui/coLearningModalTheme';
import {
  enrichMuseumShare,
  getLockedShareMessage,
  getMuseumAttemptAction,
} from '../utils/museumShareAccess';

export default function MuseumActivityLockModal({ share, onClose }) {
  const navigate = useNavigate();
  if (!share) return null;

  const enriched = enrichMuseumShare(share) || share;
  const attempt = getMuseumAttemptAction(enriched);
  const message = getLockedShareMessage(enriched);

  const goAttempt = () => {
    console.log('[MuseumActivityLockModal] Navigate to attempt:', attempt.to, {
      shareTitle: enriched.title,
      activityId: enriched.activityId,
    });
    onClose();
    if (attempt.state) {
      navigate(attempt.to, { state: attempt.state });
    } else {
      navigate(attempt.to);
    }
  };

  return (
    <CoLearningPromptBackdrop>
      <div
        className="w-full max-w-md rounded-2xl bg-white p-6 shadow-xl"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="text-center">
          <div className="mb-4 text-6xl">🔒</div>
          <h3 className={`mb-3 text-2xl font-bold ${coLearningInkTitle}`}>Activity Locked</h3>
          <p className={`mb-4 text-left text-sm leading-relaxed ${coLearningInkBody}`}>{message}</p>
          {attempt.hint ? (
            <p className={`mb-5 text-left text-xs leading-relaxed text-[#6B5948]`}>{attempt.hint}</p>
          ) : null}
          <div className="flex flex-col gap-3">
            <button
              type="button"
              onClick={goAttempt}
              className="w-full rounded-full bg-gradient-to-r from-amber-500 to-orange-500 px-6 py-3 text-sm font-semibold text-white shadow-md transition hover:brightness-105"
            >
              {attempt.label}
            </button>
            <button
              type="button"
              onClick={onClose}
              className="w-full rounded-full bg-gray-200 px-6 py-3 text-sm font-semibold text-gray-800"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </CoLearningPromptBackdrop>
  );
}
